import routerOptions0 from "/tmp/build_ea07ccf6/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/tmp/build_ea07ccf6/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}